import {
  Component,
  ViewChild,
  Injector,
  ReflectiveInjector,
  ComponentFactoryResolver,
  ViewContainerRef,
  OnInit,
  OnDestroy
} from "@angular/core";

import * as _ from "lodash";
import { Subscription } from "rxjs";

import { PrintService } from "../../print.service";
import { Print } from "../../classes/print";
import { PrintRef } from "../../classes/ref";
import { PrintParams } from "../../classes/params";
import { PrintParamsData } from "../../print.interface";

@Component({
  selector: "uex-print-wrapper",
  templateUrl: "./wrapper.component.html",
  host: {
    class: "uex-print-wrapper"
  }
})
export class PrintWrapperComponent implements OnInit, OnDestroy {
  @ViewChild("content", { read: ViewContainerRef, static: false })
  content: ViewContainerRef;

  constructor(
    private _printService: PrintService,
    private _compiler: ComponentFactoryResolver
  ) {}

  private _subscriptions: Subscription[] = [];

  public printInstance: Print;

  public get printing(): boolean {
    return this.printInstance && this.printInstance.printing;
  }
  public set printing(status: boolean) {
    if (this.printInstance) {
      this.printInstance.printing = status;
    }
  }

  public get params(): PrintParamsData {
    return this.printInstance ? this.printInstance.params : null;
  }

  public ngOnInit() {
    this._subscriptions.push(
      this._printService.onPrintPrepare.subscribe(print => {
        this.printInstance = print;
        this._prepare();
      })
    );
  }

  public ngOnDestroy() {
    this._subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  private _prepare() {
    this.printInstance.preparePrint();

    setTimeout(() => {
      const printParams: PrintParams = new PrintParams();
      const printRef: PrintRef = new PrintRef();
      printParams.params = this.params;
      printRef._printInstance = this.printInstance;
      const injector: Injector = ReflectiveInjector.resolveAndCreate([
        { provide: PrintRef, useValue: printRef },
        { provide: PrintParams, useValue: printParams }
      ]);
      const compiled_component = this._compiler.resolveComponentFactory(
        this.printInstance.component
      );
      this.content.createComponent(compiled_component, null, injector);
    }, 100);
  }
}
